/**
 * Klucz pojedynczej odpowiedzi: „czyja" i „w której kategorii".
 *
 * Mieszka w `shared`, bo używają go obie strony — serwer trzyma pod nim
 * sprzeciwy i głosy, klient renderuje po nim przyciski. Dwie osobne
 * implementacje tego samego formatu rozjechałyby się przy pierwszej zmianie,
 * a objaw byłby taki, że głosowanie po prostu nic nie robi.
 *
 * Separatorem jest dwukropek, i to nie jest obojętny wybór:
 *
 *   * **nie bajt NUL** — te klucze lądują w kolumnie JSONB, a PostgreSQL
 *     odrzuca ten bajt w tekście („unsupported Unicode escape sequence").
 *     Zapis partii padłby przy pierwszym zgłoszonym sprzeciwie.
 *   * **nie spacja** — kategorie mogą pochodzić od hosta („marka auta"),
 *     a klucz czytany wzrokowo w logach ma być jednoznaczny.
 *
 * Rozbijamy na pierwszym wystąpieniu, więc kategoria może zawierać dwukropek
 * bez szkody. Identyfikator gracza to liczba zapisana jako tekst i nigdy go
 * nie zawiera.
 */
const SEPARATOR = ":";
export function answerKey(playerId, category) {
    return `${playerId}${SEPARATOR}${category}`;
}
export function parseAnswerKey(key) {
    const index = key.indexOf(SEPARATOR);
    if (index === -1)
        return { playerId: key, category: "" };
    return { playerId: key.slice(0, index), category: key.slice(index + 1) };
}
//# sourceMappingURL=answer-key.js.map